import Seo from "@/components/base/Seo";
import Hero from "@/pages/home/components/Hero";
import HowItWorks from "@/pages/home/components/HowItWorks";
import CategorySection from "@/pages/home/components/CategorySection";
import LatestLeads from "@/pages/home/components/LatestLeads";
import BountyPreview from "@/pages/home/components/BountyPreview";
import TrustSection from "@/pages/home/components/TrustSection";
import FaqSection from "@/pages/home/components/FaqSection";
import CtaBand from "@/pages/home/components/CtaBand";
import { faqs } from "@/mocks/faqs";

const homeJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "爆料51",
    url: "https://guilinzsw.cn/",
    inLanguage: "zh-CN",
    description: "面向全网开放的公众线索征集与悬赏平台。",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://guilinzsw.cn/leads?keyword={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "爆料51",
    url: "https://guilinzsw.cn/",
    email: "tips@baoliao51.com",
    description:
      "爆料51 是面向全网开放的线索征集平台，围绕公共议题收集真实、可核实的信息，并设立悬赏机制鼓励提供线索。",
    contactPoint: {
      "@type": "ContactPoint",
      email: "tips@baoliao51.com",
      contactType: "线索征集",
      availableLanguage: "zh-CN",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  },
];

export default function Home() {
  return (
    <>
      <Seo
        title="爆料51 | 全网线索征集平台 · 悬赏找线索"
        description="爆料51是面向全网开放的线索征集平台，悬赏征集令进行中。有线索你就来，提交有价值的公众线索即可对接核实，让真相浮出水面。"
        keywords="爆料51,线索征集,悬赏线索,找线索,征集令,提供线索"
        path="/"
        jsonLd={homeJsonLd}
      />
      <Hero />
      <HowItWorks />
      <CategorySection />
      <LatestLeads />
      <BountyPreview />
      <TrustSection />
      <FaqSection />
      <CtaBand />
    </>
  );
}